<!--  -->
<template>
  <div class="twin">
    <div class="tips">企业认证</div>
    <div>获得多项资质证书</div>
    <div class="twinMain">
      <div v-for="(item, index) in serviceList" :key="index" class="every">
        <img :src="item.img" alt="" />
        <div class="everyName">{{ item.name }}</div>
        {{ item.text }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      serviceList: [
        {
          name: "ISO20000体系认证",
          img: require("@/assets/Frame1171275930.png"),
          text: "在IT服务方面达到国际认证标准",
        },
        {
          name: "ISO9001认证",
          img: require("@/assets/Frame1171275930(1).png"),
          text: "2018质量管理体系认证权威认可",
        },
        {
          name: "中国软件企业认证",
          img: require("@/assets/Frame1171275930(2).png"),
          text: "获得中国软件企业的认证资质",
        },
        {
          name: "等保三级认证",
          img: require("@/assets/Frame1171275930(3).png"),
          text: "公安部备案认证",
        },
      ],
    };
  },
  computed: {},
  watch: {},
  methods: {},
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
.twin {
  text-align: center;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #141414;
  background: #ffffff;
  line-height: 36px;
  padding: 80px 360px;
  .tips {
    font-weight: 500;
    font-size: 28px;
    color: #141414;
    margin-bottom: 5px;
  }
  .twinMain {
    margin-top: 50px;
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .every {
      width: 24%;
      margin-bottom: 20px;
      text-align: center;
      .everyName {
        font-weight: bold;
        font-size: 16px;
        color: #1c87ff;
      }
      img {
        width: 120px;
        height: 120px;
        margin-bottom: 15px;
      }
    }
  }
}

/* 在小屏幕上使用单列布局 */
@media (max-width: 768px) {
  .twin {
    padding: 80px 180px;
  }
}
</style>
